<!-- =========================================================================================
  File Name: CompanyEditProfile.vue
  Description: Entity Edit profile
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="vx-card">
    <div id="user-edit-profile">
      <div class="vx-row">
        <div class="vx-col w-full">
          <h3>Entity Profile</h3>
        </div>
      </div>

      <!-- Content Row -->
      <div class="vx-row mt-4">
        <div class="vx-col md:w-1/2 w-full">
          <vs-input class="w-full" label="VAT Code (Optional)" v-model="data_local.VATCode" name="VATCode" v-validate="'max:25'" />
          <span class="text-danger text-sm"  v-show="vErrors.has('VATCode')">{{ vErrors.first('VATCode') }}</span>
        </div>
      </div>

      <!-- Content Row -->
      <div class="vx-row mt-4">
        <div class="vx-col w-1/3">
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>Bank Details</label>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-radio
                      v-model="data_local.IsBankDetails"
                      vs-name="data_local.IsBankDetails"
                      vs-value="1"
                      name="IsBankDetails"
                      v-validate="'required|included:0,1'"
                      class="mr-2 lg:mr-6 xl:mr-10"
              >
                Yes
              </vs-radio>
              <vs-radio
                    v-model="data_local.IsBankDetails"
                    vs-name="data_local.IsBankDetails"
                    vs-value="0"
                    name="IsBankDetails"
              >
                No
              </vs-radio>
            </div>
          </div>
        </div>

        <div class="vx-col w-1/3">
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>Report Chamber of Commerce Certificate</label>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-radio
                      v-model="data_local.IsReportChamberOfCommerceCertificate"
                      vs-name="data_local.IsReportChamberOfCommerceCertificate"
                      v-validate="'required|included:0,1'"
                      name="IsReportChamberOfCommerceCertificate"
                      vs-value="1"
                      class="mr-2 lg:mr-6 xl:mr-10"
              >
                Yes
              </vs-radio>
              <vs-radio
                      v-model="data_local.IsReportChamberOfCommerceCertificate"
                      vs-name="data_local.IsReportChamberOfCommerceCertificate"
                      name="IsReportChamberOfCommerceCertificate"
                      vs-value="0"
              >
                No
              </vs-radio>
            </div>
          </div>
        </div>

        <div class="vx-col w-1/3">
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>PI Insurance</label>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-radio
                      v-model="data_local.IsPIInsurance"
                      vs-name="data_local.IsPIInsurance"
                      v-validate="'required|included:0,1'"
                      name="IsPIInsurance"
                      vs-value="1"
                      class="mr-2 lg:mr-6 xl:mr-10"
              >
                Yes
              </vs-radio>
              <vs-radio
                      v-model="data_local.IsPIInsurance"
                      vs-name="data_local.IsPIInsurance"
                      name="IsPIInsurance"
                      vs-value="0"
              >
                No
              </vs-radio>
            </div>
          </div>
        </div>
      </div>

      <!-- Content Row -->
      <div class="vx-row mt-4">
        <div class="vx-col w-1/3">
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>RUI</label>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-radio
                      v-model="data_local.IsRUI"
                      vs-name="data_local.IsRUI"
                      v-validate="'required|included:0,1'"
                      name="IsRUI"
                      vs-value="1"
                      class="mr-2 lg:mr-6 xl:mr-10"
              >
                Yes
              </vs-radio>
              <vs-radio
                      v-model="data_local.IsRUI"
                      vs-name="data_local.IsRUI"
                      name="IsRUI"
                      vs-value="0"
              >
                No
              </vs-radio>
            </div>
          </div>
        </div>

        <div class="vx-col w-1/3">
          <vs-input class="w-full" label="RUI Reference" v-model="data_local.RUIReference" name="RUIReference" v-validate="'max:25'" />
          <span class="text-danger text-sm"  v-show="vErrors.has('RUIReference')">{{ vErrors.first('RUIReference') }}</span>
        </div>

        <div class="vx-col w-1/3">
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>Visura</label>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-radio
                      v-model="data_local.IsVisura"
                      vs-name="data_local.IsVisura"
                      v-validate="'required|included:0,1'"
                      name="IsVisura"
                      vs-value="1"
                      class="mr-2 lg:mr-6 xl:mr-10"
              >
                Yes
              </vs-radio>
              <vs-radio
                      v-model="data_local.IsVisura"
                      vs-name="data_local.IsVisura"
                      name="IsVisura"
                      vs-value="0"
              >
                No
              </vs-radio>
            </div>
          </div>
        </div>
      </div>

        <!-- Content Row -->
      <div class="vx-row mt-4">
        <div class="vx-col w-full">
          <vs-input class="w-full" label="Financial Statements (Optional)" v-model="data_local.FinancialStatements" name="FinancialStatements" v-validate="'max:255'" />
          <span class="text-danger text-sm"  v-show="vErrors.has('FinancialStatements')">{{ vErrors.first('FinancialStatements') }}</span>
        </div>
      </div>

      <!-- Content Row -->
      <div class="vx-row mt-4">
        <div class="vx-col md:w-1/2 w-full">
          <vs-input class="w-full" label="Additional Name (Optional)" v-model="data_local.AdditionalName"
                    name="AdditionalName" />
          <span class="text-danger text-sm"  v-show="vErrors.has('AdditionalName')">{{ vErrors.first('AdditionalName') }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <vs-input class="w-full" label="Note (Optional)" v-model="data_local.Note" name="Note" v-validate="'max:255'" />
          <span class="text-danger text-sm"  v-show="vErrors.has('Note')">{{ vErrors.first('Note')
            }}</span>
        </div>
      </div>

      <!-- Content Row -->
      <div class="vx-row mt-4" v-if="hasLloyds">
        <div class="vx-col md:w-1/2 w-full">
          <vs-input class="w-full" label="Syndicate Acronym (Optional)" v-model="data_local.SyndicateAcronym" name="SyndicateAcronym" v-validate="'max:25'" />
          <span class="text-danger text-sm"  v-show="vErrors.has('SyndicateAcronym')">{{ vErrors.first('SyndicateAcronym') }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <vs-input class="w-full" label="Syndicate Number (Optional)" v-model="data_local.SyndicateNumber" v-validate="'alpha_num|max:25'" name="SyndicateNumber" />
          <span class="text-danger text-sm"  v-show="vErrors.has('SyndicateNumber')">{{ vErrors.first('SyndicateNumber') }}</span>
        </div>
      </div>

      <!-- Content Row -->
      <div class="vx-row mt-4" v-if="hasLloyds">
        <div class="vx-col md:w-1/2 w-full">
          <label class="vs-input--label">Market Short</label>
          <div class="marketShort">{{ marketShort }}</div>
        </div>
      </div>

      <!-- Content Row -->
      <div class="vx-row mt-4">
        <div class="vx-col md:w-1/2 w-full">
          <vs-input class="w-full" label="Account Executive (Optional)" v-model="data_local.AccountExecutive" name="AccountExecutive" />
          <span class="text-danger text-sm"  v-show="vErrors.has('AccountExecutive')">{{ vErrors.first('AccountExecutive') }}</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  components: {
    vSelect
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    hasLloyds: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.value)),
    }
  },
  computed: {
    marketShort() {
      if (!this.hasLloyds) {
        return '';
      }

      const acronym = (this.data_local.SyndicateAcronym) ? this.data_local.SyndicateAcronym : '';
      const number = (this.data_local.SyndicateNumber) ? this.data_local.SyndicateNumber : '';

      return acronym + number;
    }
  },
  watch: {
    data_local: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
  }
}
</script>

<style lang="scss">
  .marketShort {
    padding-left: 5px;
  }
</style>
